// extracted by mini-css-extract-plugin
export default {"img":"TrustedBy_img__nlXrc","trusted":"TrustedBy_trusted__etor7","text":"TrustedBy_text__yrHYO","imgChild":"TrustedBy_imgChild__KHqkG"};